import React, { ReactElement, Component, useState, useContext, useEffect, useMemo } from "react";
import { injectIntl } from 'react-intl';
import { Col, Row, List, Descriptions, Transfer, Input } from "antd";
import { ThemeContext } from '../../contexts/theme';
import { QuotaContext, quota_type } from "../../contexts/quota-management";
import { http_get, http_request, destroy_worker } from "../../worker/http-func";
import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import { NamespaceContext, namespaces_type_item } from "../../contexts/namespaces";
import { item, ItemsContext } from "../../contexts/items";
import { ItemSelectedContext } from "../../contexts/item-selected";
import { TransferItem } from "antd/lib/transfer";
import TableList from "../../components/table-list/table-list";
import { CardSelectableContext } from "../../contexts/card-selectable";
import { TableDescContext } from "../../contexts/table-desc";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { SearchOutlined } from '@ant-design/icons';
import { PaginationConfig } from "antd/lib/pagination";
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";
import { UnitContext } from "../../contexts/unit";
import { DatacenternameContext } from "../../contexts/datacenter-name";

export interface key_value {
    [key: string]: string;
}

const QuotaScale: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    // const [search_value, set_search_value]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>('');
    const [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(WorkspaceContext),
        [namespaces, set_namespaces]: [namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>] = useContext(NamespaceContext),
        theme: string = useContext(ThemeContext)[0],
        [quotas, set_quotas]: [quota_type['items'], React.Dispatch<React.SetStateAction<quota_type['items']>>] = useContext(QuotaContext),
        [item_selected, set_item_selected]: [item, React.Dispatch<React.SetStateAction<item>>] = useContext(ItemSelectedContext),
        set_items: React.Dispatch<React.SetStateAction<item[]>> = useContext(ItemsContext)[1],
        set_table_desc: React.Dispatch<React.SetStateAction<string[]>> = useContext(TableDescContext)[1],
        search_value: string = useState<string>('')[0],
        unit_provide: string = useContext(UnitContext)[0],
        //  [visible, set_visible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [quota_table, set_quota_table]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState<JSX.Element>(<p></p>),
        [target_keys, set_target_keys]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>([]),
        [selected_keys, set_selected_keys]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>([]),
        [data_source, set_data_source]: [workspaces_type_item[] | namespaces_type_item[], React.Dispatch<React.SetStateAction<workspaces_type_item[] | namespaces_type_item[]>>] = useState<workspaces_type_item[] | namespaces_type_item[]>([]),
        //  [quota_selected, set_quota_selected]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
        [assign_spaces, set_assign_spaces]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
        set_card_selectable: React.Dispatch<React.SetStateAction<boolean>> = useContext(CardSelectableContext)[1],
        [cluster_selected, set_cluster_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(ClusterSelectedContext),
        [workspace_selected, set_workspace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(WorkSpaceSelectedContext),
        [namespace_selected, set_namespace_selected]: [item | undefined, React.Dispatch<React.SetStateAction<item | undefined>>] = useContext(NameSpaceSelectedContext),
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        //  [is_disabled, set_is_disabled]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
        //  [filter_props, set_filter_props]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>(['']),

        path = useMemo(() => props.history.location.pathname.substring(1), [props.history.location.pathname]),
        is_quota: boolean = useMemo(() => path.indexOf('quota') > -1, [path]),
        is_workspace: boolean = useMemo(() => path.indexOf('workspace') > -1, [path]),
        { formatMessage } = useMemo(() => props.intl, [props.intl]);

    useEffect(() => () => { destroy_worker() }, []);
    useEffect((): void => {
        const cluster_selected_name: string | null = sessionStorage.getItem('cluster'),
            workspace_selected_name: string | null = sessionStorage.getItem('workspace'),
            namespace_selected_name: string | null = sessionStorage.getItem('namespace');

        !cluster_selected && cluster_selected_name && set_cluster_selected({ name: cluster_selected_name });
        !workspace_selected?.name && workspace_selected_name && set_workspace_selected({ name: workspace_selected_name });
        !namespace_selected?.name && namespace_selected_name && set_namespace_selected({ name: namespace_selected_name });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect((): void => {
        is_workspace ? user_info.role !== '' && datacenter_name && http_get('workspace_scale_page', ['workspaces', set_workspaces, 'workspacequotas', set_quotas], user_info.role, user_info.subscription_id, datacenter_name, cluster_selected?.name || '') : user_info.role !== '' && datacenter_name && http_get('namespace_scale_page', ['workspaces', set_workspaces], user_info.role, user_info.subscription_id, datacenter_name, cluster_selected?.name || '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [set_quotas, set_workspaces, set_namespaces, path, user_info.role, user_info.subscription_id]);

    useEffect((): void => {
        if (user_info.role !== '' && workspace_selected?.name && !is_workspace && datacenter_name) {
            const url: string = `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ''}/workspace/${workspace_selected.name}`;
            http_request('namespaces', props, set_namespaces, `${url}/namespaces`, 0, user_info.role, user_info.subscription_id, datacenter_name, (cluster_selected || {}).name || '');
            http_request('namespacequotas', props, set_quotas, `${url}/namespacequotas`, 0, user_info.role, user_info.subscription_id, datacenter_name, '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cluster_selected?.name, is_workspace, workspace_selected?.name, set_namespaces, user_info.role, user_info.subscription_id, set_quotas]);

    useEffect((): void => {
        if (is_workspace && (workspaces || []).length) {
            const wkdata: string = sessionStorage.getItem('workspace') || '';
            const wkselected = workspaces?.find((workspace: workspaces_type_item) => workspace?.metadata?.name === wkdata);
            if (wkselected) set_item_selected({ quotaName: wkselected.spec.workspacequota })
            else if (workspaces) {
                const { spec }: workspaces_type_item = workspaces[0];
                set_item_selected({ quotaName: spec.workspacequota });
            }
        }
        else if ((namespaces || []).length) {
            const nsdata: string = sessionStorage.getItem('namespace') || '';
            const nsselected: namespaces_type_item | undefined = namespaces && namespaces.find((namespace: namespaces_type_item) => namespace.metadata.name === nsdata);
            if (nsselected) set_item_selected({ quotaName: ((((nsselected || {}).metadata) || {}).labels || {}).namespacequota })
            else {
                const data = namespaces && namespaces[0] && namespaces[0].metadata;
                set_item_selected({ quotaName: (((data || {}).labels) || {}).namespacequota });
            }
        }
    }, [is_workspace, workspaces, namespaces, set_item_selected]);

    useEffect((): void => {
        if (user_info.role !== '' && !is_workspace && datacenter_name) {
            const wks = sessionStorage.getItem('workspace');
            const binded_wks = workspaces?.filter(workspace => workspace?.metadata?.name === wks);
            if (binded_wks && binded_wks[0]) {
                const url: string = `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected?.name || ''}/workspace/${(((binded_wks || {})[0] || {}).metadata || {}).name}`;
                http_request('namespacequotas', props, set_quotas, `${url}/namespacequotas`, 0, user_info.role, user_info.subscription_id, datacenter_name, '');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [is_workspace, workspaces, set_namespaces, cluster_selected, user_info.role, user_info.subscription_id, set_quotas, datacenter_name]);

    useEffect((): void => {
        set_card_selectable(false);
    }, [set_card_selectable]);

    useEffect((): void => {
        set_table_desc([`${is_workspace ? formatMessage({ id: 'workspace' }) : formatMessage({ id: 'namespace' })}${formatMessage({ id: 'quotas' })}`, `${is_workspace ? formatMessage({ id: 'workspace_scale_desc' }) : formatMessage({ id: 'namespace_scale_desc' })}.`]);
    }, [set_table_desc, is_workspace, formatMessage]);

    useEffect((): void => {
        let name: string | null;
        if (is_quota) {
            name = sessionStorage.getItem('item_selected');
            const quota_new: any = quotas.filter(quota => name && quota.metadata.name === name).map(
                quota => {
                    const spec = quota.spec, quotas_each = spec.quotas && spec.quotas;
                    // delete spec['quotas'];
                    // return { cpu: { limitCPU: quotas_each && quotas_each.limitCPU }, memory: { limitMemory: quotas_each && quotas_each.limitMemory }, ...quota.metadata };
                    return {
                        cpu: { limitCPU: quotas_each && quotas_each.limitCPU },
                        memory: { limitMemory: quotas_each && quotas_each.limitMemory },
                        // @ts-ignore
                        rootfs: { limitsRootfs: quotas_each && quotas_each.limitsRootfs },
                        pod: { limitsPod: quotas_each && quotas_each.limitsPod },
                        pvc: { limitsDisk: quotas_each && quotas_each.limitsDisk },
                        quotas: quotas_each,
                        ...quota.metadata
                    };
                })[0];
            quota_new && set_item_selected(quota_new);
        } else {
            let space_found, item_new;
            name = sessionStorage.getItem('workspace');
            space_found = workspaces && workspaces.find(workspace => name === workspace.metadata.name);
            item_new = space_found && [space_found].map(
                (workspace: workspaces_type_item) => {
                    return (
                        ({
                            name, labels
                        }) => ({
                            name, labels, quotaName: (workspace || {}).spec?.workspacequota
                        }))(workspace.metadata)
                })[0];
            item_new && set_workspace_selected(item_new);
            if (!is_workspace) {
                name = sessionStorage.getItem('namespace');
                space_found = namespaces && namespaces?.find(namespace => name === namespace.metadata.name);
                item_new = space_found && [space_found].map(
                    (namespace: namespaces_type_item) => {
                        return (
                            ({
                                name, labels
                            }) => ({
                                name, quotaName: labels && labels.namespacequota
                            }))(namespace.metadata)
                    })[0];
                item_new && set_namespace_selected(item_new);
            }
        }
    }, [quotas, item_selected.name, set_item_selected, set_items, workspaces, namespaces, path, is_quota, is_workspace, set_namespace_selected, set_workspace_selected])

    useEffect(() => {
        if (!is_quota) {
            const quotas_new: any = Array.isArray(quotas) && quotas.map(
                quota => {
                    const spec = quota.spec, quotas_each = spec.quotas && spec.quotas, name = quota.metadata.name, uid = quota.metadata.uid;
                    let limitsCPU, limitMemory, limitsRootfs, pods, gpu, limitsDisk, persistentvolumeclaims, configmaps, secrets, services;
                    if (quotas_each) {
                        limitsCPU = quotas_each.limitCPU ? (quotas_each.limitCPU === '*' ? 'Unlimited' : quotas_each.limitCPU) : 'Unlimited';
                        limitMemory = quotas_each.limitMemory ? (quotas_each.limitMemory === '*' ? 'Unlimited' : quotas_each.limitMemory) : 'Unlimited';
                        limitsRootfs = quotas_each.limitsRootfs ? (quotas_each.limitsRootfs === '*' ? 'Unlimited' : quotas_each.limitsRootfs) : 'Unlimited';
                        pods = quotas_each.pods ? (quotas_each.pods === '*' ? 'Unlimited' : quotas_each.pods) : 'Unlimited';
                        gpu = quotas_each.gpu ? (quotas_each.gpu === '*' ? 'Unlimited' : quotas_each.gpu) : 'Unlimited';
                        limitsDisk = quotas_each.limitsDisk ? (quotas_each.limitsDisk === '*' ? 'Unlimited' : quotas_each.limitsDisk) : 'Unlimited';
                        persistentvolumeclaims = quotas_each.persistentvolumeclaims ? (quotas_each.persistentvolumeclaims === '*' ? 'Unlimited' : quotas_each.persistentvolumeclaims) : 'Unlimited';
                        configmaps = quotas_each.configmaps ? (quotas_each.configmaps === '*' ? 'Unlimited' : quotas_each.configmaps) : 'Unlimited';
                        secrets = quotas_each.secrets ? (quotas_each.secrets === '*' ? 'Unlimited' : quotas_each.secrets) : 'Unlimited';
                        services = quotas_each.services ? (quotas_each.services === '*' ? 'Unlimited' : quotas_each.services) : 'Unlimited';
                    }

                    return {
                        // @ts-ignore
                        uid,
                        // @ts-ignore
                        name,
                        limitsCPU,
                        limitMemory,
                        limitsRootfs,
                        pods,
                        gpu,
                        limitsDisk,
                        persistentvolumeclaims,
                        configmaps,
                        secrets,
                        services,
                        quotas: quotas_each,
                        ...quota.metadata
                    };
                });
            if (((path.includes('workspace') ? workspace_selected : namespace_selected)?.quotaName) && quotas_new) {
                const quota_name: string | undefined = (path.includes('workspace') ? workspace_selected : namespace_selected)?.quotaName;
                const quotas_new_bind: any = Array.isArray(quotas_new) && quotas_new.filter(quota => {
                    return quota.name === quota_name
                });
                const quotas_new_unbind: any = Array.isArray(quotas_new) && quotas_new.filter(quota => {
                    return quota.name !== quota_name
                })
                const quotas_new_end: any = quotas_new_bind.concat(quotas_new_unbind);
                set_items(quotas_new_end)
            } else {
                set_items(quotas_new);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quotas, is_quota, set_items, unit_provide])

    // const quotas_2 = [
    //     {
    //         name: 'quota01', description: [
    //             { key: 'limits.cpu', value: '0' },
    //             { key: 'limits.memory', value: '0' },
    //             { key: 'limits.ephemeral-storage', value: '0' },
    //             { key: 'requests.storage', value: '0' },
    //             { key: 'persistentvolumeclaims', value: '0' },
    //             { key: 'services', value: '0' },
    //             { key: 'secrets', value: '0' },
    //             { key: 'configmaps', value: '0' },
    //             { key: 'pods', value: '0' },
    //         ]
    //     },
    // {
    //     name: 'quota02', description: [
    //         { key: 'limits.cpu', value: '0' },
    //         { key: 'requests.cpu', value: '0' },
    //         { key: 'limits.memory', value: '0' },
    //         { key: 'requests.memory', value: '0' },
    //         { key: 'limits.ephemeral-storage', value: '0' },
    //         { key: 'requests.ephemeral-storage', value: '0' },
    //         { key: 'requests.storage', value: '0' },
    //         { key: 'test', value: '0' },
    //         { key: 'persistentvolumeclaims', value: '0' },
    //         { key: 'test', value: '0' },
    //         { key: 'services', value: '0' },
    //         { key: 'services.loadbalancers', value: '0' },
    //         { key: 'services.nodeports', value: '0' },
    //         { key: 'secrets', value: '0' },
    //         { key: 'configmaps', value: '0' },
    //         { key: 'replicationcontrollers', value: '0' },
    //         { key: 'deployments.apps', value: '0' },
    //         { key: 'replicasets.apps', value: '0' },
    //         { key: 'statefulsets.apps', value: '0' },
    //         { key: 'jobs.batch', value: '0' },
    //         { key: 'cronjobs.batch', value: '0' },
    //         { key: 'deployments.extensions', value: '0' },
    //         { key: 'resourcequotas', value: '0' },
    //         { key: 'pods', value: '0' },
    //     ]
    // },
    // {
    //     name: 'quota03', description: [
    //         { key: 'limits.cpu', value: '0' },
    //         { key: 'requests.cpu', value: '0' },
    //         { key: 'limits.memory', value: '0' },
    //         { key: 'requests.memory', value: '0' },
    //         { key: 'limits.ephemeral-storage', value: '0' },
    //         { key: 'requests.ephemeral-storage', value: '0' },
    //         { key: 'requests.storage', value: '0' },
    //         { key: 'test', value: '0' },
    //         { key: 'persistentvolumeclaims', value: '0' },
    //         { key: 'test', value: '0' },
    //         { key: 'services', value: '0' },
    //         { key: 'services.loadbalancers', value: '0' },
    //         { key: 'services.nodeports', value: '0' },
    //         { key: 'secrets', value: '0' },
    //         { key: 'configmaps', value: '0' },
    //         { key: 'replicationcontrollers', value: '0' },
    //         { key: 'deployments.apps', value: '0' },
    //         { key: 'replicasets.apps', value: '0' },
    //         { key: 'statefulsets.apps', value: '0' },
    //         { key: 'jobs.batch', value: '0' },
    //         { key: 'cronjobs.batch', value: '0' },
    //         { key: 'deployments.extensions', value: '0' },
    //         { key: 'resourcequotas', value: '0' },
    //         { key: 'pods', value: '0' },
    //     ]
    // },
    // {
    //     name: 'quota04', description: [
    //         { key: 'limits.cpu', value: '0' },
    //         { key: 'requests.cpu', value: '0' },
    //         { key: 'limits.memory', value: '0' },
    //         { key: 'requests.memory', value: '0' },
    //         { key: 'limits.ephemeral-storage', value: '0' },
    //         { key: 'requests.ephemeral-storage', value: '0' },
    //         { key: 'requests.storage', value: '0' },
    //         { key: 'test', value: '0' },
    //         { key: 'persistentvolumeclaims', value: '0' },
    //         { key: 'test', value: '0' },
    //         { key: 'services', value: '0' },
    //         { key: 'services.loadbalancers', value: '0' },
    //         { key: 'services.nodeports', value: '0' },
    //         { key: 'secrets', value: '0' },
    //         { key: 'configmaps', value: '0' },
    //         { key: 'replicationcontrollers', value: '0' },
    //         { key: 'deployments.apps', value: '0' },
    //         { key: 'replicasets.apps', value: '0' },
    //         { key: 'statefulsets.apps', value: '0' },
    //         { key: 'jobs.batch', value: '0' },
    //         { key: 'cronjobs.batch', value: '0' },
    //         { key: 'deployments.extensions', value: '0' },
    //         { key: 'resourcequotas', value: '0' },
    //         { key: 'pods', value: '0' },
    //     ]
    // }
    // ];

    // const handle_ok = () => {
    //     // assign(quota_selected);
    //     set_visible(false);
    // }

    // const handle_cancel = () => {
    //     set_visible(false);
    // }

    // const assign = async (quota_name: string | undefined): Promise<void> => {
    //     await is_workspace ?
    //         http_request('assign_quota', set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ''}/workspace/${item_selected.uid}`, 2, { metadata: { name: item_selected.name }, spec: { workspacequota: quota_name } })
    //         :
    //         http_request('assign_quota', set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ''}/namespace/${item_selected.name}`, 2, { metadata: { labels: { namespacequota: quota_name, workspace: item_selected.labels && item_selected.labels.workspace } } })
    //     const item_selected_new = item_selected;
    //     item_selected_new.quotaName = quota_name;
    // }

    const pagination_config: PaginationConfig = {
        size: 'small',
        pageSize: 3,
        hideOnSinglePage: true
    };

    // const quota_props = (
    //     <Select
    //         allowClear
    //         showArrow
    //         showSearch
    //         mode="multiple"
    //         notFoundContent="Not Found"
    //         size='large'
    //         style={{ width: '100%' }}
    //         defaultValue="quota.name">
    //         <Option value="quota.name" key="name">
    //             <Row>
    //                 <Col>quota name</Col>
    //             </Row>
    //         </Option>
    //         {quotas_2[0].description.map(quota => <Option value={quota.key} key={quota.key}>
    //             <Row>
    //                 <Col>{quota.key}</Col>
    //             </Row>
    //         </Option>)}
    //     </Select>
    // )

    useEffect((): void => {
        let quota_found_id: number = 0;
        if (Array.isArray(quotas)) quotas.findIndex(quota => quota.metadata.name === item_selected.quotaName);
        const quota_found = (quotas || {})[quota_found_id];

        const get_rest_of_array = () => {
            const quotas_filtered = quotas.filter(quota => quota.metadata.name.toLocaleLowerCase().indexOf(search_value.toLocaleLowerCase().trim()) > -1).sort((a, b) => {
                const a_name = a.metadata.name;
                return a_name === item_selected.quotaName ? -1 : (a_name.localeCompare(b.metadata.name));
            });
            quotas_filtered.splice(quota_found_id, 1);
            return quotas_filtered;
        }
        const quota_table_new: JSX.Element =
            <List
                pagination={pagination_config}
                itemLayout="horizontal"
                dataSource={is_quota ? (item_selected.name && [quotas.find(quota => quota.metadata.name === item_selected.name)]) || [] : quota_found && [quota_found, ...get_rest_of_array()]}
                size="small"
                renderItem={quota => (
                    quota && <List.Item actions={[
                        <span className={`font-12 font-w-6 ${quota.metadata.name === item_selected.quotaName ? 'binded_quota' : ''} d-inline text-ellipsis`}>{quota.metadata.name}</span>
                    ]}>
                        <List.Item.Meta
                            description={
                                <Descriptions size="small" column={{ sm: 1, md: 2, lg: 4 }} bordered style={quota.metadata.name === item_selected.quotaName ? { boxShadow: `0 0 6px 1px ${theme}` } : {}}>
                                    {quota.spec.quotas && Object.keys(quota.spec.quotas).map((key: string) =>
                                        <Descriptions.Item className="w-120 text-ellipsis w-max-100" label={key} key={key}>{(quota.spec.quotas as key_value)[key]}</Descriptions.Item>
                                    )}
                                </Descriptions>
                            }
                        />
                    </List.Item>
                )}
            />
        set_quota_table(quota_table_new);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quotas, search_value, theme, item_selected.quotaName, is_quota, item_selected.name]);

    useEffect((): void => {
        if (is_quota) {
            let labels;
            const data_source_new: workspaces_type_item[] | namespaces_type_item[] | undefined = is_workspace ?
                workspaces?.map((workspace: workspaces_type_item) => {
                    labels = workspace.metadata.labels;
                    return { key: labels && labels.name, ...workspace }
                })
                :
                namespaces ? namespaces.filter((namespace: namespaces_type_item) => (namespace.metadata.labels && namespace.metadata.labels.workspace) === (item_selected.labels && item_selected.labels.workspace))
                    .map((namespace: namespaces_type_item) => { return { key: namespace.metadata.name, ...namespace } }) : [];
            data_source_new && set_data_source(data_source_new);
            const target_keys_new: string[] = is_workspace ?
                (data_source_new as workspaces_type_item[]).filter((data: workspaces_type_item) => data.spec.workspacequota === item_selected.name).map(workspace => workspace.metadata.labels.name)
                :
                (data_source_new as namespaces_type_item[]).filter((data: namespaces_type_item) => data.metadata.labels && data.metadata.labels.namespacequota === item_selected.name).map(namespace => namespace.metadata.name);
            set_target_keys(target_keys_new);
            set_selected_keys([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workspaces, namespaces, is_quota, path, item_selected.labels, item_selected.name])

    const handleChange = (targetKeys: string[], direction: string, moveKeys: string[]): void => {
        if (user_info.role && datacenter_name) {
            set_target_keys(targetKeys);
            let workspace_selected: workspaces_type_item | undefined;
            direction === 'right' ?
                targetKeys.forEach((targetKey: string) => {
                    if (is_workspace) {
                        workspace_selected = workspaces?.find(workspace => workspace.metadata.labels.name === targetKey);
                        workspace_selected && workspace_selected.metadata && http_request('assign_quota', props, set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ''}/workspace/${workspace_selected.metadata.name}`, 2, user_info.role, user_info.subscription_id, datacenter_name, (cluster_selected || {}).name || '', { metadata: { name: workspace_selected.metadata.labels.name }, spec: { workspacequota: item_selected.name } })
                    } else http_request('assign_quota', props, set_namespaces, `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ''}/namespace/${targetKey}`, 2, user_info.role, user_info.subscription_id, datacenter_name, (cluster_selected || {}).name || '', { metadata: { labels: { namespacequota: item_selected.name, workspace: item_selected.labels && item_selected.labels.workspace } } })
                })
                :
                moveKeys.forEach((moveKey: string) => {
                    if (is_workspace) {
                        workspace_selected = workspaces?.find(workspace => workspace.metadata.labels.name === moveKey);
                        workspace_selected && workspace_selected.metadata && http_request('assign_quota', props, set_workspaces, `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ''}/workspace/${workspace_selected.metadata.name}`, 2, user_info.role, user_info.subscription_id, datacenter_name, (cluster_selected || {}).name || '', { metadata: { name: workspace_selected.metadata.labels.name }, spec: { workspacequota: undefined } })
                    }
                    else http_request('assign_quota', props, set_namespaces, `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ''}/namespace/${moveKey}`, 2, user_info.role, user_info.subscription_id, datacenter_name, (cluster_selected || {}).name || '', { metadata: { labels: { namespacequota: undefined, workspace: item_selected.labels && item_selected.labels.workspace } } })
                })
        }
    }

    const handleSelectChange = (sourceSelectedKeys: string[], targetSelectedKeys: string[]): void => {
        set_selected_keys([...sourceSelectedKeys, ...targetSelectedKeys])
    }

    useEffect((): void => {
        let assign_spaces_new: string = '';
        const data_source_new: workspaces_type_item[] | namespaces_type_item[] = is_workspace ?
            (data_source as workspaces_type_item[]).filter((data: workspaces_type_item) => data.spec.workspacequota === item_selected.name)
            :
            (data_source as namespaces_type_item[]).filter((data: namespaces_type_item) => data.metadata.labels && data.metadata.labels.namespacequota === item_selected.name);
        (data_source_new as any[]).forEach((item: workspaces_type_item & namespaces_type_item, index: number): void => {
            assign_spaces_new += (is_workspace ? item.metadata.labels.name : item.metadata.name) + (index !== data_source_new.length - 1 ? ', ' : '')
        })
        is_quota && set_assign_spaces(assign_spaces_new);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data_source, is_quota, path])

    return (
        is_quota ? <Col className="px-20">
            <Row className="card box_rounded card_bg operations">
                <Col>
                    <Row align="middle">
                        <Col sm={14}>
                            <div className="card_title no_color big_font">
                                <span className="pointer d-inline" onClick={() => { props.history.push(`${is_workspace ? '/workspaces/workspaces' : '/workspace-info/namespaces'}`) }} />
                                <span className="ml-10">Quotas</span>
                            </div>
                            <div className="card_title no_color small_font">Resources quota is used to restrict the user resources consumption of a mechanism, applied to workspace.</div>
                        </Col>
                        <Col sm={10}>
                            <Row>
                                <Col sm={12} className="text-right text-white font-w-6">
                                    <div className="font-13 text-center text-ellipsis">{is_quota ? item_selected.name : (item_selected.quotaName || 'N/A')}</div>
                                    <div className="text-center">Current Quota</div>
                                </Col>
                                {!is_quota ? <Col sm={12} className="text-right text-white font-w-6">
                                    <div className="font-13 text-center text-ellipsis">{quotas.length}</div>
                                    <div className="text-center">Available Quotas</div>
                                </Col>
                                    :
                                    <Col sm={12} className="text-right text-white font-w-6" title={assign_spaces}>
                                        <div className="font-13 text-center text-ellipsis w-max-300">{assign_spaces || 'N/A'}</div>
                                        <div className="text-center">Assigned {is_workspace ? 'Workspaces' : 'Namespaces'}</div>
                                    </Col>}
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mt-10">
                        <Col>
                            <Row>
                                <Col className="select_no_border">
                                    <Input
                                        className="box_rounded input_no_border"
                                        size="large"
                                        allowClear
                                        placeholder={`Please input quota name`}
                                        value={search_value}
                                        prefix={<SearchOutlined />}
                                    />
                                </Col>
                                {/* <Col sm={4}>
                                <Slider range defaultValue={[20, 50]} disabled={is_disabled} onAfterChange={(e) => {set_search_value(e.toString().replace(',', '--'))}} />
                            </Col> */}
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            {/* <Modal
                title={'Bind quota'}
                visible={visible}
                onOk={handle_ok}
                onCancel={handle_cancel}>
                {`The quota of workspace has been binded to ${item_selected.quotaName}. Are you sure to change it to ${quota_selected} ?`}
            </Modal> */}
            <Row className="card global box_rounded">
                <div className="card_title card_underline card_header_title">Available Quotas({quotas.length})</div>
                <Col className="operations">
                    {quota_table}
                </Col>
            </Row>
            {
                is_quota && <Row className="card global box_rounded" justify="center">
                    <Transfer
                        dataSource={data_source as unknown as TransferItem[]}
                        titles={['Source', 'Target']}
                        targetKeys={target_keys}
                        selectedKeys={selected_keys}
                        onChange={handleChange}
                        onSelectChange={handleSelectChange}
                        render={item => is_workspace ? item.metadata.labels.name : item.metadata.name}
                    />
                </Row>
            }
        </Col> : <div className="px-20 mt-20"><TableList /></div>
    )
}

export default injectIntl(QuotaScale);